const TYPES = {
	BOOLEAN:        'boolean',
	/** Запись в фиде: «Отметка <титул> установлена/удалена» */
	BOOLEAN_MARK:         'booleanMark',
	OBJECT:               'object',
	NUMBER:               'number',
	NUMBER_PERCENT:       'numberPercent',
	STRING:               'string',
	INT_RANGE:            'intRange',
	DATE_RANGE:           'dateRange',
	DATE:                 'date',
	DATE_TIME:            'dateTime',
	PRICE:                'price',
	TENDER_BID:           'tenderBid',
	SUM:                  'sum',
	PAYMENT_TERM:         'paymentTerm',
	SUPPLY_OFFER:         'supplyOffer',
	MANUFACTURERS:        'manufacturers',
	COORDINATES:          'coordinates',
	TENDER_PARTICIPATION: 'tenderParticipation',
  REFUSAL_REASONS:      'refusalReasons',
  TARIFFS:              'tariffs',
  TRANSPORT_DOWNTIME_REASON: 'transportDownTime',
} as const;

export default TYPES;
